import { ga_video_event } from "./VideoAnalytics";

/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
/* eslint-disable no-useless-return */

const $ = document.querySelector.bind(document);

var timerVideo;
var isBusy = false;

class VignetteBL {
    /**
     * Functions that takes in two parameters and injects a video into the passed DOM.
     *  Make sure you have a script that initalizes ynet video api
     * @param {*} yitvideoId is the video's vignette id
     * @param {*} node The node you want to inject the video to, (note: pass in an html node)
     */

    static injectVideo(yitvideoId, node) {
        if (!yitvideoId || !node) return;

        // Setting up the div to inject
        const videoDom = document.createElement('div');
        videoDom.classList.add('vignette-video');

        videoDom.setAttribute('yitVideo', yitvideoId);
        videoDom.setAttribute('id', yitvideoId);

        // injection
        // *This line doesnt work with prevention checks if there is no video already existing with this id, preventing double injection

        const videoNode = document.querySelector(`*[id^="player_${yitvideoId}"]`);

        !videoNode && node.appendChild(videoDom);


        const removeDoubleVideo = () => {
            let videos = window.document.querySelectorAll("video");
            if (videos.length == 0) {
                clearTimeout(timerVideo);
            }

            for (let i = 0; i < videos.length; i++) {
                if (videos[i].parentElement.className.indexOf("vignette-video") > -1
                    || videos[i].className.indexOf("html5_api") == -1) {
                    videos[i].remove();
                }
            }
            timerVideo = window.setTimeout(removeDoubleVideo, 1000);
        }


        window.YitVideo.InfrastructureReInitialize();
        // window.setTimeout(() => {
        //     if (isBusy == true) {
        //         return;
        //     }
        //     isBusy = true;
        //     new Promise(function (resolve, reject) {
        //         setTimeout(function () {
        //             resolve(1);
        //         }, 500);
        //     }).then(function () {

        //         return "";
        //         //}
        //     }).then(function () {
        //         // setTimeout(window.YitVideo.InitPlayers, 1000);
        //     }).then(d => {
        //         isBusy = false;
        //     }).catch(e => {
        //         console.warn('caught on the second catch of vignette')
        //     });
        //     //removeDoubleVideo();
        // }, 500);

    }

    /**
     * Function that injects a vignette article to the doms that are passed (class names of the doms)
     * @param {*} headerNodeClass Pass in the class name of the header DOM Element you want to inject TO
     * @param {*} bodyNodeClass Pass in the class name of the DOM Element you want the body of the article to be injected to
     * @param {*} videoNodeClass Pass in the class name of the DOM Element you want the video to be injected (REQUIRED FOR VIDEO INJECTION)
     * @param {*} fetchHTMLResponse Pass in the callback data of the api after text formatting
     * @param {*} setLoader if you have a loader state, pass it here
     * @param {*} injectInPlace If true inject video as it is in vignette article fetched
     * @param {*} injectInTopOrBottom If true injects video on provided spot - top/bottom, if this is true it also do not inject video in its original position
     * @param {*} cb access to the vignette video id
     */
    static injectArticle(
        headerNodeClass,
        bodyNodeClass,
        videoNodeClass = null,
        fetchHTMLResponse,
        setLoader = null,
        injectInPlace = true,
        injectInTopOrBottom = false,
        cb = null,
    ) {
        // Time out to load the dom // Necessary

        const fetchedArticleData = new DOMParser().parseFromString(fetchHTMLResponse, 'text/html');
        const parsedArticleData = fetchedArticleData.querySelector('body .artiwrapper');

        if (parsedArticleData) {
            // sets loader to false
            setLoader && setLoader(false);

            const headerNode = document.querySelector(`.${headerNodeClass}`);
            const bodyNode = document.querySelector(`.${bodyNodeClass}`);

            if (videoNodeClass || injectInPlace) {
                let videoNode;
                if (videoNodeClass)
                    videoNode = document.querySelector(`.${videoNodeClass}`);

                // the nodes that the videos resent in the vignette article
                const vignetteArticleVideosNodes = parsedArticleData.childNodes[1].querySelectorAll(
                    'span .flp6ScriptContainer',
                );

                // all the id's of the vignette videos in the article
                const videosId = Array.from(vignetteArticleVideosNodes).map(node =>
                    parseInt(node.getAttribute('id')),
                );

                // const videoId = parseInt(vignetteArticleVideosNode.getAttribute('id'));

                // if selected inject in place, injects video as the current vignette fetch
                // Additional check for injectInTopOrBottom because it its true we dont want to render video in its original position
                injectInPlace && !injectInTopOrBottom &&
                    vignetteArticleVideosNodes.forEach((node, index) => {
                        const currentVideoId = videosId[index];
                        currentVideoId && this.injectVideo(videosId[index], node);
                    });

                // Call back to have access to the vignette video id
                cb && cb(videosId, videoNode);
            }

            // Parsing the data to the header and the body
            const articleHeader = parsedArticleData.childNodes[0];
            const articleBody = parsedArticleData.querySelector('span');

            headerNode.appendChild(articleHeader);
            bodyNode.appendChild(articleBody);

            window.setTimeout(() => {
                const blueLinks = document.querySelectorAll('.bluelink');
                blueLinks.forEach(link => {
                    link.setAttribute('target', '_blank');
                });
            }, 2000);
        }
    }

    /**
     *
     * @param {*} articleVignetteId the article vignette id to be fetched
     * @param {*} cb callback with the html data of the request
     */
    static fetchArticle(articleVignetteId, articleVersion, cb) {
        fetch(
            `https://z.ynet.co.il/mshort/content/api/YnetArticle/GetArticle.aspx?articleID=${articleVignetteId}${articleVersion ? `&version=${articleVersion}` : ""}`,
        )
            .then(res => res.text())
            .then(data => {
                cb(data);
            })
            .catch(err => console.error(err));
    }

    static VignetteVideoApiScriptEnable(scriptSrc) {
        // Returns early if script already exists, prevent infinite injections of the script
        if ($(`script[src=${scriptSrc}]`)) return;

        const $script = document.createElement('script');
        $script.setAttribute('async', 'true');
        $script.setAttribute('id', 'yitvideo_player');
        $script.setAttribute('src', scriptSrc || 'https://www.ynet.co.il/Common/Api/Scripts/YitVideo.js?q=234dxsf45');
        $script.onload = () => {
            window.YitVideo.Constructor({
                containerAttrPrefix: 'yitVideo',
                dynamicPlayerType: false,
                flaotOnScroll: false,
                nextVideo: false,
                popularity: true,
                siteName: 'ynet',
                disableAds: true,
                dcPath: window.dcPath ? window.dcPath : "",
                adTagUrl: '',
                eventsCallback(event, data) {},
            });
        }

        //Appending the script
        return $('head').appendChild($script);

        //Usual src: https://www.ynet.co.il/Common/Api/Scripts/YitVideo.js
    }
}

export default VignetteBL;
